import { CHAT_TOKEN_LIMITS } from '@upright/common/iam/entitlement/plan-caps';
import { quotaAllowanceOf } from '@upright/common/iam/entitlement/licence';
import { EntitlementKey } from '@upright/common/iam/entitlement/registry';
import { getOrganizationOfUser } from '@upright/common/iam/organizations/common';
import { User } from '@upright/common/iam/users/types';
import type { TokenLimitCtaVariant } from './use-token-limit-cta-variant';

/**
 * The CTA for a user whose chat is charged to an organization on the record (the organization chat
 * charges, `getOrganizationOfUser`): the tier its licence's `chat_tokens` allowance reaches, or
 * 'pro', the neutral CTA, when the licence holds none. Undefined when that organization is not on the
 * record, so the legacy signals decide; another organization's licence never answers for it.
 */
export function findLicensedTokenLimitCtaVariant(
  user: Pick<User, 'groups'> | undefined,
): TokenLimitCtaVariant | undefined {
  const organizationId = user ? getOrganizationOfUser(user)?.id : undefined;
  if (!user || organizationId === undefined) return undefined;
  const licence = user.groups.find(group => group.licence?.organizationId === organizationId)?.licence;
  if (!licence) return undefined;
  const limit = quotaAllowanceOf(licence, EntitlementKey.CHAT_TOKENS)?.limit;
  if (limit === undefined) return 'pro';
  if (limit >= CHAT_TOKEN_LIMITS.enterprise) return 'enterprise';
  return limit >= CHAT_TOKEN_LIMITS.pro ? 'pro' : 'starter';
}
